<template>
    <div>
        <v-dialog :modelValue="dialog_view" max-width="750" @click:outside="close" @keydown.esc="close">
            <v-card>
                <v-card-title class="headline">
                    {{ title }} - Orden #{{ code }} 
                </v-card-title>

                <v-card-text>

                    <div class="row">
                        <div class="col-md-12">
                            <v-data-table :headers="headers" :items="list" :search="search" :loading="loading"
                                loading-text="Cargando...">
                                <template v-slot:item="props">
                                    <tr>
                                        <td>{{ props.item.date_time }}</td>
                                        <td>{{ props.item.user.name }}</td>
                                        <td>
                                            <span class="status-badge" :class="'status-envio-' + props.item.status.id">
                                                {{ props.item.status.name }}
                                            </span>
                                        </td>
                                        <td><span class="status-badge">{{ props.item.sub_status != null ? props.item.sub_status.name : "-" }}</span></td>
                                    </tr>
                                </template>
                                <template v-slot:no-results>
                                    <v-alert :value="true" color="error" icon="warning">
                                        {{ "Busqueda sin resultados - " + search }}
                                    </v-alert>
                                </template>
                            </v-data-table>
                        </div>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn color="red darken-1" text @click="close()"> Cerrar </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { formatUtils } from "@/libs/utils/formatUtils";
import { shipmentOrderService } from "@/libs/ws/shipmentOrderService";

export default {
    components: {},
    mixins: [],
    props: {
        title: String,
        dialog_view: Boolean,
        shipment_order_id: Number,
        code: Number
    },
    data: () => ({
        list: [],
        formatUtils: formatUtils,
        defaultItem: null,
        loading: false,
        search: "",
        headers: [
            { title: "Fecha", align: "left", sortable: true, key: "date_time" },
            { title: "Usuario", align: "left", sortable: true, key: "user.name" },
            { title: "Estado", align: "left", sortable: true, key: "status.name" },
            { title: "Sub estado", align: "left", sortable: true, key: "sub_status.name" },
        ],
        pagination: {
            page: 1,
            itemsPerPage: 5,
        },
    }),
    created: function () {
        window.addEventListener("keydown", (e) => {
            if (e.key == "Escape") {
                this.close();
            }
        });
    },
    watch: {
        dialog_view(val) {
            if (val) {
                this.loadList();
            }
        },
    },
    mounted() { },
    methods: {
        updatePagination(pagination) {
            this.pagination = pagination;
        },

        close() {
            this.list = [];
            this.$emit("closeDialog");
        },

        loadList() {
            this.loading = true;

            const param = {
                shipment_order_id: this.shipment_order_id,
            };

            shipmentOrderService
                .get_historial(param)
                .then((response) => {

                    this.list = response.result;
                    this.loading = false;
                })
                .catch((e) => {
                    console.log("service.filter error");
                    console.log(e);
                    this.loading = false;
                });
        },
    },
};
</script>